var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KIconButton',{attrs:{"tooltip":"Add","text":"Large button","icon":"plus","size":"large","appearance":"raised-button"}})
}
var staticRenderFns = []

export { render, staticRenderFns }